module.exports = __webpack_public_path__ + "/images/logo-hellowish-white.cf76a7b.webp";